// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
import router from "./router";
import "babel-polyfill";
import axios from "axios";
axios.defaults.withCredentials = true;
Vue.prototype.axios = axios;
import iView, { Spin } from "view-design";
// 将Spin挂载到Vue对象原型上
Vue.prototype.$Spin = Spin;
import "view-design/dist/styles/iview.css";
import "@/assets/css/common.css";
Vue.config.productionTip = false;
Vue.use(iView);
import myCharts from "@/assets/api/myecharts.js";
Vue.use(myCharts);
import "animate.css";
// import "wowjs/css/libs/animate.css";
// import VueCropper from 'vue-cropper'

// import "../src/assets/api/swiper.css";
// import Swiper from "swiper";
// require("swiper/dist/css/swiper.css");

import "../src/assets/api/swiper.css";
import Swiper from "swiper";
import "swiper/dist/css/swiper.min.css";
// import VueAwesomeSwiper from "vue-awesome-swiper";
// Vue.use(VueAwesomeSwiper);
// import "swiper/dist/css/swiper.min.css";
// import "@/assets/js/jquery-2.1.4.js";
// import "@/assets/js/FileSaver.js";
// import "@/assets/js/jquery.wordexport.js";

/* eslint-disable no-new */
window.vm = new Vue({
  el: "#app",
  router,
  components: { App },
  template: "<App/>"
});
// this.$Spin.show()
// iView.Spin.show()
// setTimeout(() => {
//     iView.Spin.hide()
// }, 3000);
axios.interceptors.request.use(
  config => {
    iView.Spin.show();
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);
axios.interceptors.response.use(
  res => {
    iView.Spin.hide();
    if (res.data.code == 0) {
      //   console.log(1);
      return res.data;
    } else if (res.data.code == 101) {
      //   console.log(2);
      iView.Message.error(res.data.message);
      setTimeout(() => {
        router.replace({ path: "/login" });
      }, 1000);
    } else {
      //   console.log(3);
      iView.Message.error(res.data.message);
    }
  },
  error => {
    console.log("main.js:error......");
    iView.Spin.hide();
    iView.Message.error(error);
  }
);
//存储cookie
Vue.prototype.setCookie = function(name, value) {
  var exp = new Date();
  exp.setTime(exp.getTime() + 60 * 60 * 1000);
  document.cookie =
    name + "=" + escape(value) + ";expires=" + exp.toGMTString();
};

// 清空所有cookie
Vue.prototype.clearAllCookie = function() {
  var date = new Date();
  date.setTime(date.getTime() - 10000);
  var keys = document.cookie.match(/[^ =;]+(?=\=)/g);
  if (keys) {
    for (var i = keys.length; i--; )
      document.cookie =
        keys[i] + "=''; expire=" + date.toGMTString() + "; path=/";
  }
};
//时间戳转时间格式
Vue.prototype.formateDateTime = function(shijianchuo, type) {
  if (!shijianchuo) {
    shijianchuo = Date.parse(new Date());
  }
  shijianchuo = parseInt(shijianchuo);
  var date = new Date(shijianchuo);
  var yyyy = date.getFullYear(); //获取完整的年份(4位,1970)
  var m = date.getMonth() + 1; //获取月份(0-11,0代表1月,用的时候记得加上1)
  if (m.toString().length == 1) {
    m = "0" + m;
  }
  var d = date.getDate(); //获取日(1-31)
  if (d.toString().length == 1) {
    d = "0" + d;
  }
  var h = date.getHours(); //获取小时数(0-23)
  if (h.toString().length == 1) {
    h = "0" + h;
  }
  var mm = date.getMinutes(); //获取分钟数(0-59)
  if (mm.toString().length == 1) {
    mm = "0" + mm;
  }
  var s = date.getSeconds(); //获取秒数(0-59)
  if (s.toString().length == 1) {
    s = "0" + s;
  }
  var datetime = "";
  if (!type) {
    datetime = yyyy + "-" + m + "-" + d;
  }
  if (type == 1) {
    datetime = yyyy + "-" + m + "-" + d + " " + h + ":" + mm + ":" + s;
  }
  return datetime;
};

//上传文件类型错误
Vue.prototype.handleFormatError = function(file) {
  this.$Spin.hide();
  this.$Notice.warning({
    title: "文件格式不正确",
    desc: "文件 " + file.name + " 格式不正确，请重新选择。"
  });
};
//   上传文件失败
Vue.prototype.handleError = function(res) {
  console.log(res);
  this.$Spin.hide();
  this.$Message.error("导入失败");
};
// 获取评价人员类型select
// import { getSelectAssessType } from "@/assets/api/api";
// Vue.prototype.getSelectAssessTypeF = function() {
//   getSelectAssessType()
//     .then(res => {
//       this.assessTypeSelect = res.data.items;
//     })
//     .catch(err => {});
// };

//获取栏目的类型列表
//   moduleId 1产品中心 5新闻动态
import { getLmlxList } from "@/assets/api/api";
Vue.prototype.getLmlxListF = function(moduleId) {
  getLmlxList(moduleId)
    .then(res => {
      console.log(res);
      if (moduleId == 1) {
        this.lmlxList = res.data;
      } else if (moduleId == 5) {
        this.xwlxList = res.data;
      }
    })
    .catch(err => {});
};

//   获取各栏目的列表
//   moduleId 1产品中心  2企业动态  5我们的品牌故事

import { WOW } from "wowjs";
import { getPageViewList } from "@/assets/api/api";
Vue.prototype.getPageViewListF = function(
  moduleId,
  programma,
  pageSize,
  pageNum,
  cb,
  keyWords
) {
  getPageViewList({
    pageSize,
    pageNum,
    moduleId,
    programma,
    keyWords: keyWords ? keyWords : ""
  })
    .then(res => {
      this.pageTotal = res.data.total;
      if (moduleId == 1) {
        this.cpzxList = [];
        this.cpzxList = res.data.rows;
        new WOW({
          boxClass: "wow-2"
        }).init();
        console.log(this.cpzxList);
      } else if (moduleId == 2) {
        this.qydtList = [];
        this.qydtList = res.data.rows;
        new WOW({
          boxClass: "wow-4"
        }).init();
      } else if (moduleId == 3) {
        this.ppgsList = [];
        this.ppgsList = res.data.rows;
      } else if (moduleId == 5) {
        this.xwdtList = [];
        this.xwdtList = res.data.rows;
      }
      console.log(cb);
      if (cb) {
        console.log(12333);
        cb();
      }
    })
    .catch(err => {});
};
//   获取各栏目的列表
//
import { getPageViewList_2 } from "@/assets/api/api";
Vue.prototype.getPageViewListF_2 = function(pageSize, pageNum) {
  getPageViewList_2({
    pageSize,
    pageNum
  })
    .then(res => {
      this.pageTotal = res.data.total;
      this.qydtList = [];
      this.qydtList = res.data.rows;
      new WOW({
        boxClass: "wow-4"
      }).init();
    })
    .catch(err => {});
};



// WEBPACK FOOTER //
// ./src/main.js